module.exports = __webpack_public_path__ + "static/steelheadtrout-dac6a9c5f81f14ce0d9457e0ac1127ff.jpg";